"use strict"

/**
 * Busy state for the application status search.
 *
 * The search is an ordinary GET navigation, so there is nothing to stream in - the job
 * here is to acknowledge the click immediately and stop a second one. The state is torn
 * down on pageshow because browsers restore a cached page with the DOM exactly as it was
 * left, which would otherwise show a spinner on a page that is not loading anything.
 */
const StatusSearch = function () {
    const form = document.querySelector('#status-search-form')
    if (!form) {
        return { init: function () { } }
    }

    const button = form.querySelector('#status-search-btn')
    const label = button?.querySelector('[data-search-label]')
    const spinner = button?.querySelector('[data-search-spinner]')

    const setBusy = function (busy) {
        if (!button) {
            return
        }

        button.disabled = busy
        button.setAttribute('aria-busy', busy ? 'true' : 'false')

        if (spinner) {
            spinner.classList.toggle('d-none', !busy)
        }

        if (label) {
            label.textContent = busy ? 'Searching...' : 'Search'
        }

        if (typeof RbfPageLoader !== 'undefined') {
            busy ? RbfPageLoader.show('Searching') : RbfPageLoader.hide()
        }
    }

    // Every search shows the spinner for at least this long. A lookup that returns in
    // 80ms otherwise flashes the spinner for a frame, which reads as a glitch rather than
    // as work being done.
    const MinimumBusyMs = 1500

    return {
        init: function () {
            form.addEventListener('submit', function (evt) {
                // Native validation runs before this event, so anything reaching here is a
                // form that would have submitted.
                if (form.dataset.searchHeld === 'true') {
                    return
                }

                evt.preventDefault()
                setBusy(true)
                form.dataset.searchHeld = 'true'

                window.setTimeout(function () {
                    // form.submit() deliberately, not requestSubmit(): it does not re-fire
                    // this handler, so there is no risk of looping back into the delay.
                    form.submit()
                }, MinimumBusyMs)
            })

            // Covers the back button restoring this page from the bfcache. The held flag
            // has to be cleared too, or the restored page would submit instantly on the
            // next click without ever showing the spinner.
            window.addEventListener('pageshow', function () {
                form.dataset.searchHeld = 'false'
                setBusy(false)
            })
        }
    }
}()

document.addEventListener('DOMContentLoaded', function () {
    StatusSearch.init()

    // The destination field is only on the page when an assessor has opened it for
    // correction, so this is a no-op the rest of the time.
    if (window.CountryFlagSelect && window.jQuery) {
        window.CountryFlagSelect.enhance('[data-country-select]', {
            placeholder: 'Select every destination',
            closeOnSelect: false
        })
    }
})
